import {Grid, InputAdornment} from "@mui/material";
import { ControlledTextField } from "src/components/forms";
import { useFormContext } from "react-hook-form";
import {ChangeEvent, useState} from "react";
import {SolicitationFinancePreferencesFields} from "../../../../../types/financing/financingData";
import {HttpCacheClientFolder} from "../../../../../http/cache/client/httpCacheClientFolder";
import {ControlledAutocomplete} from "../../../../../components/forms/ControlledAutocomplete";
import {HttpCacheOperation} from "../../../../../http/cache/httpCacheOperation";
import {HttpCacheGeneral} from "../../../../../http/cache/httpCacheGeneral";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {HttpCacheAmortization} from "../../../../../http/cache/httpCacheAmortizationSystem";



const FinancialDetail = () => {

    const {control, setValue} = useFormContext();
    const [numberMount, setNumberMount] = useState<string>('')
    const [numberGuarantee, setNumberGuarantee] = useState<string>('')
    const [error, setError] = useState<boolean>(false)

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setNumberMount(e.target.value)
        setValue(SolicitationFinancePreferencesFields.Amount, e.target.value)
        setError(parseInt(e.target.value) < parseInt(numberGuarantee))
    }
    const handleChangeGuarantee = (e: ChangeEvent<HTMLInputElement>) => {
        setNumberGuarantee(e.target.value)
        setValue(SolicitationFinancePreferencesFields.Guarantee, e.target.value)
        setError(parseInt(e.target.value) > parseInt(numberMount))
    }
    

    return (
        <Grid container>
            <Grid item xs={12}>
                <ControlledAutocomplete loadOptions={HttpCacheClientFolder.getComerciales}
                                        control={control}
                                        name={SolicitationFinancePreferencesFields.CommercialCode}
                                        label={'Oficial comercial de FOGABA'}
                                        valueField={EntityWithIdFields.Id}
                />
            </Grid>
            <Grid container alignItems={'center'} spacing={3}>
                <Grid item xs={6}>
                    <ControlledTextField name={SolicitationFinancePreferencesFields.Amount}
                                         label={'Monto del crédito solicitado'}
                                         control={control}
                                         currency
                                         fullWidth
                                         onChange={handleChange}
                                         error={error}
                                         required
                    />
                </Grid>
                <Grid item xs={6} pb={2}>
                    <ControlledAutocomplete
                        loadOptions={HttpCacheGeneral.getBanks}
                        name={SolicitationFinancePreferencesFields.BankCode}
                        control={control}
                        label={'Banco de preferencia'}
                        valueField={EntityWithIdFields.Id}
                    />
                </Grid>
            </Grid>
            <Grid container alignItems={'center'} spacing={3} item xs={12}>
                <Grid item xs={6}>
                    <ControlledTextField name={SolicitationFinancePreferencesFields.Guarantee}
                                         label={'Monto de la garantía solicitada'}
                                         control={control}
                                         currency
                                         fullWidth
                                         onChange={handleChangeGuarantee}
                                         error={error}
                                         helperText={error ? 'La garantia no puede superar al monto solicitado' : ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <ControlledTextField
                        name={SolicitationFinancePreferencesFields.Term}
                        label='Plazo de la operación'
                        control={control}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>meses</InputAdornment>
                        }}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <Grid container alignItems={'center'} spacing={3} item xs={12}>
                <Grid item xs={8} pb={2}>
                    <ControlledAutocomplete
                        name={SolicitationFinancePreferencesFields.RateTypeCode}
                        label='Tasa (T.N.A.)'
                        control={control}
                        loadOptions={HttpCacheOperation.getRateModes}
                        valueField={EntityWithIdFields.Id}
                    />
                </Grid>
                <Grid item xs={4}>
                    <ControlledTextField
                        name={SolicitationFinancePreferencesFields.Rate}
                        label='Tasa de interés'
                        control={control}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>%</InputAdornment>
                        }}
                        fullWidth
                    />
                </Grid>
            </Grid>
            <Grid container alignItems={'center'} spacing={3} item xs={12}>
                <Grid item xs={6} pb={2}>
                    <ControlledAutocomplete
                        name={SolicitationFinancePreferencesFields.AmortizationSystemCode}
                        label='Sistema de amortización'
                        control={control}
                        loadOptions={HttpCacheAmortization.getAmortizationTypes}
                        valueField={EntityWithIdFields.Id}
                    />
                </Grid>
                <Grid item xs={6} pb={2}>
                    <ControlledAutocomplete
                        name={SolicitationFinancePreferencesFields.PeriodicityCode}
                        label='Periodicidad'
                        control={control}
                        loadOptions={HttpCacheOperation.getPeriodicity}
                        valueField={EntityWithIdFields.Id}
                    />
                </Grid>
            </Grid>
            <Grid container alignItems={'center'} spacing={2} item xs={12}>
                <Grid item xs={6}>
                    <ControlledTextField
                        name={SolicitationFinancePreferencesFields.GraceMonths}
                        label='Período de gracia'
                        control={control}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>meses</InputAdornment>
                        }}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default FinancialDetail;